import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ScTableSummary } from '../../../../models/table.model';

@Component({
  selector: 'sc-table-summary',
  templateUrl: './sc-table-summary.component.html',
  styleUrls: ['./sc-table-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScTableSummaryComponent implements OnInit {
  @Input() summaryList: ScTableSummary[];

  constructor() {}

  ngOnInit() {}
}
